import { Button, Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import React from "react";

import { useTl } from "../../hooks";

import { ICustomButtonProps } from "./ICustomButtonProps";

interface ISaveButtonProps extends ICustomButtonProps {}

export const SaveButton: React.FunctionComponent<ISaveButtonProps> = ({
  minimal = true,
  onClick,
  loading,
  disabled,
  intent = Intent.PRIMARY,
  text,
  style,
  className,
}) => {
  const { t } = useTl();
  return (
    <Button
      icon={IconNames.FLOPPY_DISK}
      onClick={onClick}
      text={minimal ? null : text || t("Save")}
      intent={intent}
      loading={loading}
      disabled={disabled}
      type={onClick ? "button" : "submit"}
      style={style}
      className={className}
    />
  );
};
